/**
 * @copyright chuzhixin 1204505056@qq.com
 * @description 路由守卫，目前两种模式：all模式与intelligence模式
 */
import router from "@/router";
import store from "@/store";
import getPageTitle from "@/utils/pageTitle";
import {
  authentication,
  loginInterception,
  recordRoute,
  routesWhiteList,
} from "./settings";

router.beforeEach(async (to, from, next) => {
  let hasToken = store.getters["user/accessToken"];
  const now = (new Date()).getTime()
  const last = store.getters["user/refresh"];
  let hasRefresh = (now - last < 600000) ? false : true
  // console.log(hasToken)
  if (!loginInterception) hasToken = true;

  // console.log(to)
  if (hasToken || hasRefresh) {
    if (to.path === "/login") {
      next();
    } else {
      await store.dispatch("user/getUserInfo");
      const hasPermissions = store.getters["user/permissions"] && store.getters["user/permissions"].length > 0;

      if (hasPermissions && !hasRefresh) {
        next();
      } else {
        try {
          let permissions;
          if (!loginInterception) {
            //settings.js loginInterception为false时，创建虚拟权限
            permissions = [11, 12, 13, 21, 22, 31, 32, 41, 42, 43, 44, 51, 52, 61, 62, 71, 72, 73, 81, 82, 83, 91, 92, 93, 101, 102, 111, 112, 121, 122, 131, 132, 133, 141, 142, 143, 144, 145, 146, 151, 152, 153, 154, 161, 162, 163, 164, 171, 172, 173, 174, 175, 176, 177, 181, 182, 183, 184, 191, 192, 193, 194, 201, 202, 203, 204, 205, 211, 221, 231, 241, 242, 243, 244, 245, 251, 252, 261, 262, 263, 271, 272, 281, 282, 283, 291, 292, 293, 301, 302, 303, 311, 312, 321, 322];
            await store.dispatch("user/setPermissions", permissions);
          } else {
            permissions = await store.dispatch("user/getUserInfo");
            console.log(permissions)
            if (permissions === null) {
              next(`/login?redirect=${to.path}`);
            }
          }
          // console.log(permissions)
          let accessRoutes = [];
          if (authentication === "intelligence") {
            accessRoutes = await store.dispatch(
              "routes/setRoutes",
              permissions
            );
          } else if (authentication === "all") {
            accessRoutes = await store.dispatch("routes/setAllRoutes");
          }
          await store.dispatch("user/setRefresh", now);
          console.log(accessRoutes)
          router.addRoutes(accessRoutes);
          if (to.path === "/") {
            next("/login");
          } else {
            next({ ...to, replace: true });
          }
        } catch {
          // console.log('重置TOKEN')
          await store.dispatch("user/resetAccessToken");
        }
      }
    }
  } else {
    if (routesWhiteList.indexOf(to.path) !== -1) {
      console.log('白名单')
      next();
    } else {
      console.log('非白名单?')
      if (recordRoute) {
        next(`/login?redirect=${to.path}`);
      } else {
        next("/login");
      }
    }
  }
  document.title = getPageTitle(to.meta.title);
});
router.afterEach(() => {

});
